import React, {  useEffect, useState } from 'react';
import { get, pick, find } from 'lodash';
import { Button, Loader, FileUploader, Icon, Input } from '../components';
import { useSelect, useAction, useForm, useFormValidator } from '../hooks';

const initialFormData = {
  application_requirements: []
}

const rules = {
  application_requirements: 'array'
}

export const options = {
  initialFormData,
  rules
}

const RequiredDocuments = ({ onNext, onPrevious, initialValue, preview, isPassed, onSetFormWithLocalStorage }) => {
  
  const requirementList = useSelect('transactionTypeRequirement.list');
  
  const getApplicationRequirement = useAction('transactionTypeRequirement.getList')
  const getApplicationRequirementByMultipleTransactionType = useAction('transactionTypeRequirement.getListMultipleTransactionType')
  const listing = useSelect('loading.isLoading', { type: 'transactionTypeRequirement.getList' })
  const selectedTransaction = useSelect('transaction.selected', { id: process.env.REACT_APP_DEFAULT_TRANSACTION })
  // const selectedTransactionType = useSelect('transactionType.selected')
  const setSelectedTransactionTypeRequirement = useAction('transactionTypeRequirement.show')
  const selectedTransactionTypeRequirement = useSelect('transactionTypeRequirement.selected')

  const [value, { onChange, onCreateUpdateToList, onSetForm }] = useForm(initialFormData)
  const { response } = useFormValidator(value, rules)
  const appTransaction = JSON.parse(localStorage.getItem('app_transaction')) || {}
  const [ isCheckedFile, setIsCheckedFile ] = useState([])
  
  useEffect(() => {
    onSetForm(pick(initialValue, Object.keys(initialFormData)))
    // eslint-disable-next-line
  }, [Object.values(initialValue).join(',')])

  const handleSelect = requirement_id => e => {
    e.preventDefault()
    setSelectedTransactionTypeRequirement(requirement_id)
  }
  useEffect(() => {
    if(get(appTransaction, 'transaction_type_id') && +get(appTransaction, 'transaction_kind') === 1){
      getApplicationRequirement(get(selectedTransaction, 'id'), get(appTransaction, 'transaction_type_id'))
    }
  // eslint-disable-next-line
  }, [get(selectedTransaction, 'id'), get(appTransaction, 'transaction_type_id'), get(appTransaction, 'transaction_kind')])

  useEffect(() => {
    if(+get(appTransaction, 'transaction_kind') === 2){
      const transactionTypeIds = get(appTransaction, 'transaction_type_multiple').map(x => get(x, 'value'))
      getApplicationRequirementByMultipleTransactionType({ transaction_type_ids: transactionTypeIds })
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if(+get(appTransaction, 'transaction_kind') === 2)
      onSetFormWithLocalStorage(value)
    // eslint-disable-next-line
  }, [Object.values(value).join(','), +get(appTransaction, 'transaction_kind')])

  useEffect(() => {
    setIsCheckedFile(value.application_requirements)
  },[value.application_requirements])

  const handleUpload = item => {
    let data = {
      target: {
        name: 'application_requirements',
        value: {
          id: get(selectedTransactionTypeRequirement, 'attributes.requirement_id'),
          url: !get(item, 'cdnUrl') && get(file, 'url') ? get(file, 'url') : get(item, 'cdnUrl'),
          is_checked: get(item, 'cdnUrl') ? get(file, 'is_checked') : (item.target.value)
        }
      }
    }

    if(+get(appTransaction, 'transaction_kind') === 2){
      data = {
        target: {
          name: 'application_requirements',
          value: {
            id: get(selectedTransactionTypeRequirement, 'id'),
            url: !get(item, 'cdnUrl') && get(file, 'url') ? get(file, 'url') : get(item, 'cdnUrl'),
            is_checked: get(item, 'target.value')
          }
        }
      }
    }
    onCreateUpdateToList(data)
  }

  const toggleCheckbox = () => {
    let data = value.application_requirements.map((item) => {
      return { 
        id: item.id,
        url: item.url,
        is_checked: item.is_checked === 1 ? 0 : 1
       }
    })
    if(value.application_requirements.length < Object.values(requirementList).length) {
      data = Object.values(requirementList).map((item, i) => {
        return {
          id: i + 1,
          is_checked: 1
        }
      })
    }
    onChange({
      target: {
        name: 'application_requirements',
        value: data
      }
    })
  }
  
  const getFileById = (id) => (value.application_requirements && value.application_requirements.find(x => +get(x, 'id') === +id)) || null
  
  const file = +get(appTransaction, 'transaction_kind') === 2 
    ? getFileById(+get(selectedTransactionTypeRequirement, 'id'))
    : getFileById(+get(selectedTransactionTypeRequirement, 'attributes.requirement_id'))
  
  const isAllRequirementsFullfilled = +get(appTransaction, 'transaction_kind') === 2 
    ? Object.values(requirementList).filter(x => +get(x, 'attributes.is_required') === 1).every(item => {
        return get(item, 'attributes.is_required') && getFileById(get(item, 'id'))
      })
    : Object.values(requirementList).filter(x => +get(x, 'attributes.is_required') === 1).every(item => {
      return get(item, 'attributes.is_required') && getFileById(get(item, 'attributes.requirement_id'))
    })
  
  const isValidationPassed = response.is_passed && isAllRequirementsFullfilled
  
  const validate = get(value, 'application_requirements').map((x) => {
    return (x.is_checked)
  })
  const validateChecked = validate.length !== Object.values(requirementList).length ? false : validate.indexOf("") 

  return (
    <>
      <div className="flex flex-col xl:flex-row pb-3">
        <div className="w-full xl:w-4/12">
          <span className="font-bold text-sm">Required Initial Documents</span><span className="text-xs text-red-600"> (Please Acknowledge)</span>
          {listing && <Loader.Table />}
          {!listing && <div className="flex flex-col space-y-2">
            {Object.values(requirementList).map((item, i) => {
              return (
                <button onClick={handleSelect(get(item, 'attributes.requirement_id'))} type="button" key={`requirements${get(item, 'id')}`} className={`py-2 px-1 w-full ${+get(selectedTransactionTypeRequirement, 'attributes.requirement_id') === +get(item, 'attributes.requirement_id') ? 'bg-gray-300' : ''}`}>
                  <div className="flex flex-col w-full text-left space-y-2">
                    <p className="text-sm">
                      <b className="font-medium">{`${i+1}) `}</b>
                      {/* {(get(item, 'attributes.is_required') && !getFileById(get(item, 'attributes.requirement_id')))
                        ? <span className="rounded px-1 bg-info text-white text-sm mr-2">Required</span>
                        : <Icon.BoxCheck className="inline-flex mr-2"/>
                      } */}
                      <div className="inline-flex mr-2"><Input type="checkbox" value={isCheckedFile.length === Object.values(requirementList).length || isCheckedFile[i] ? get(find(isCheckedFile, { id: (i + 1) }), 'is_checked') : 0 } /></div>
                      {/* <div className="inline-flex mr-2"><input type="checkbox" name="isChecked1" checked={isCheckedFile.length === Object.values(requirementList).length || isCheckedFile[i] ? isCheckedFile[i].is_checked : 0 } onChange={handleUpload} className="!w-5 m-auto self-center"/></div> */}
                      {get(item, 'attributes.requirement_name')}
                    </p>
                    <p className="text-sm w-full border border-dashed border-white p-1 text-blue-400 ">- {get(item, 'attributes.requirement_description')}</p>
                  </div>
                </button>
              )
            })}
          </div>}
          <div>
            {!preview &&<div className="inline-flex mr-2"><span className="py-2 pr-2">Acknowledged: </span><Input type="checkbox" name="is_checked" value={get(file, 'is_checked')} onChange={toggleCheckbox}/></div>}
          </div>
        </div>
        <div className="flex-1 flex flex-col border-4 border-gray-300 rounded p-2">
          {!preview && 
          <div className="pb-2 border-b-2 border-gray-300 flex">
            <div className="flex-2">
              
              <FileUploader value={get(file, 'url') || ''} onChange={handleUpload} className="btn btn-primary !w-auto" disabled={!get(file, 'is_checked')}><Icon.Upload /><span>Upload Attachment</span></FileUploader>
            </div>
            {/* <div className="inline-flex mr-2"><span className="py-2 pr-2">Acknowledged: </span><Input type="checkbox" name="is_checked" value={get(file, 'is_checked')} onChange={handleUpload}/></div> */}
            {/* <div className="flex space-x-2 items-center">
              <span>Status: </span>
              <span className="bg-warning px-2 py-1 rounded text-sm">Approved</span>
              <span>Remarks: Uploaded</span>
            </div> */}
            <div class="flex-2 text-sm self-center ml-2 text-red-600">(optional)</div>
            
          </div>}
          <div className={`flex p-2 overflow-auto ${get(file, 'url') ? 'bg-gray-800' : ''}`} style={{ maxHeight: 600, height: 600 }}>
            {!get(file, 'url') &&
            <span className="m-auto font-bold text-md text-gray-600">No current attachment</span> }
            {get(file, 'url') && <img className="m-auto" src={get(file, 'url')} alt="attachment"/>}
          </div>
        </div>
      </div>
      {+get(appTransaction, 'transaction_kind') === 1 && !preview &&
      <div className="flex space-x-2 float-right">
        <Button type="button" onClick={onPrevious(value)} className="!bg-warning !w-auto !text-black">Previous</Button>
        <Button disabled={!isValidationPassed || validateChecked > -1} type="button" onClick={onNext(value)} className="!bg-warning !w-auto !text-black">Next</Button>
      </div>}
      {+get(appTransaction, 'transaction_kind') === 2 && !preview &&
      <div className="flex space-x-2 float-right">
        <Button disabled={!isPassed} className="!w-auto">Submit</Button>
      </div>}
    </>
  )
}

export default RequiredDocuments